import { useQuery } from "@tanstack/react-query"
import { DeviceCategoryGet } from "../app/models/DeviceCategory"
import { digitalManagerApi } from "../services/api"

export function useDeviceCategories() {
  const { data: deviceCategoriesList = [], isLoading: isLoadingDeviceCategories } =
    useQuery({
      queryKey: ["deviceCategories"],
      queryFn: () =>
        digitalManagerApi
          .get<DeviceCategoryGet[]>(`/deviceCategories`)
          .then((r) => r.data),
    })

  return {
    deviceCategoriesList,
    isLoadingDeviceCategories,
  }
}
